import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './form-container-fields.component.scss';
var FormContainerFields = /** @class */ (function (_super) {
    tslib_1.__extends(FormContainerFields, _super);
    function FormContainerFields(element) {
        return _super.call(this, element) || this;
    }
    FormContainerFields.prototype.init = function () { };
    FormContainerFields.prototype.bindEvents = function () { };
    return FormContainerFields;
}(Base));
export { FormContainerFields };



//////////////////
// WEBPACK FOOTER
// ./components/form-container-fields/form-container-fields.component.ts
// module id = 316
// module chunks = 0